export default {
  Alarms: "/alarms",
  Login: "/login",
  MainDashboard: "/main-dashboard",
};
